import { MessageCircle } from "lucide-react";

const quickLinks = [
  { href: "#programa", label: "Programa" },
  { href: "#niveles", label: "Niveles" },
  { href: "#metodologia", label: "Metodología" },
  { href: "#modalidades", label: "Modalidad" },
  { href: "#faq", label: "Preguntas frecuentes" },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-3">
        <div>
          <a href="#inicio" className="inline-flex items-center" data-testid="footer-brand-logo">
            <img
              src="/logo-footer.webp"
              alt="PIO Language Institute"
              className="h-20 w-auto"
              data-testid="footer-brand-logo-image"
            />
          </a>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
            Aprende inglés de A1 a B2 con una oferta académica dirigida a la empleabilidad.
          </p>
        </div>

        <div>
          <h3 className="font-heading font-semibold text-white text-sm uppercase tracking-wider">Enlaces</h3>
          <ul className="mt-5 space-y-3">
            {quickLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading font-semibold text-white text-sm uppercase tracking-wider">Contacto</h3>
          <a
            href="https://wa.me/573185329505?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20programa%20de%20ingl%C3%A9s"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-5 inline-flex items-center gap-3 text-sm text-slate-400 hover:text-white transition-colors"
          >
            <MessageCircle className="w-4 h-4 text-emerald-400" />
            WhatsApp: +57 318 532 9505
          </a>
          <p className="mt-4 text-sm text-slate-400">Clases 100% presenciales en nuestras sedes.</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} Politécnico PIO · Programa de Inglés</span>
          <span>Niveles A1 a B2 · Marco Común Europeo de Referencia</span>
        </div>
      </div>
    </footer>
  );
}
